import IconButton from '@components/IconButton';
import colors from '@constants/colors';
import styled from '@emotion/styled';
import ControlIcon from '@icons/Control';
import { useFlow } from '@stackflow/react';
import { useAtomValue } from 'jotai';

import { tierCalculatedDateAtom } from '../../atoms/tierAtoms';

function TierCalcFilter() {
    const { push } = useFlow();
    const calculatedDate = useAtomValue(tierCalculatedDateAtom);
    return (
        <Wrapper>
            <IconButton dot={!!calculatedDate}
                onClick={() => push('TierCalculatedDateBottomSheet', {})}>
                <ControlIcon />
            </IconButton>
        </Wrapper>
    );
}
const Wrapper = styled.div`
    padding: 0 16px;
    display: flex;
    justify-content: flex-end;
    width: 100%;
`;

export default TierCalcFilter;
